import cc from 'classcat'
import React, { ChangeEvent, useEffect, useState } from 'react'

import { getClassName } from '../../../utils/getClassName'
import { BaseInput, InputProps } from '../../Form'
import * as Styled from './styles'

export type SelectInputProps = InputProps & {
  disconnect?: boolean
  onTextChange?: (text: string) => void
  iconUrl?: string
  errorPath?: string
  isMenuVisible?: boolean
  name: string
}

export const SelectInput = React.forwardRef<HTMLInputElement, SelectInputProps>(
  (
    {
      disabled,
      disconnect,
      errorPath,
      iconUrl,
      inputSize,
      isMenuVisible,
      name,
      onBlur,
      onFocus,
      onTextChange = () => null,
      placeholder,
      required,
      value,
    }: SelectInputProps,
    ref,
  ) => {
    const [inputText, setInputText] = useState(value)

    const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
      setInputText(e.target.value)
      onTextChange(e.target.value)
    }

    useEffect(() => {
      setInputText(value)
    }, [value])

    return (
      <>
        <BaseInput
          ref={ref}
          name={name}
          placeholder={placeholder}
          type="text"
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={handleOnChange}
          value={inputText}
          autoComplete="none"
          required={required}
          disconnect={disconnect}
          errorPath={errorPath}
          className={cc([
            'for-select',
            getClassName('input-deprecated'),
            { focus: isMenuVisible, big: inputSize === 'lg' },
          ])}
          disabled={disabled}
          suffix={iconUrl && <Styled.InputPrefixImage alt="" src={iconUrl} />}
          truncate
          weight="medium"
          size={inputSize}
        />
      </>
    )
  },
)
